import useRemoteConfigQuery from 'hooks/useRemoteConfigQuery'
import { useTranslationsUpdater } from 'hooks/useTranslationsUpdater'

const RootQueries = () => {
  useRemoteConfigQuery()
  // Make sure we fetch the remote config asap
  useTranslationsUpdater()
  return null
}

export default RootQueries
